import React from "react";
import { useLoader } from "../../context/loaderContext";
import { api } from "../../config/api";
import { AxiosResponse } from "axios";
import { CircularProgress } from "@mui/material";

const LoadingOverlay: React.FC = () => {
  const { loading, setLoading } = useLoader();

  api.interceptors.request.use(
    (config) => {
      setLoading(true);
      return config;
    },
    (error) => {
      setLoading(false);
      return Promise.reject(error);
    }
  );

  api.interceptors.response.use(
    (response: AxiosResponse) => {
      setLoading(false);
      return response;
    },
    (error) => {
      setLoading(false);
      return Promise.reject(error);
    }
  );

  return (
    <>
      {loading && (
        <div
          style={{
            display: loading ? "block" : "none",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "#ffffff61",
            zIndex: 9999,
            overflow: "hidden",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              textAlign: "center",
            }}
          >
            <CircularProgress
              sx={{
                color: "#27374d",
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default LoadingOverlay;
